import React from "react";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import simple from '../../assets/images/icons/SVG/simple215.jpg'
import doble from '../../assets/images/icons/SVG/doble174.jpg'


function ResultsCalculator({limpiar, res}) {
  // console.log(res)
  return (
    <>
    { res.posible === 'Si' || res.posible2 === 'Si' ?
    <section id="results-calculator" className="px-2">
      <header aria-labelledby="results-calculator" className="pt-5 pb-2">
        <h1 className="id-section-titulonews">
        Resultado
        </h1>
      </header>
      <section
        className="resultados-calculadora settings__form-styles"
        >
        <div className="col-12 col-sm-12 col-md-6 col-lg-6 style-calculadora-izquierda">
          {/* Seccion columna izquierda */}
          
             <article className="md:w-1/2 rounded-lg formulario-styles">
              <h2>Cargas de Cálculos</h2>
              <p>
                Carga permanente accesoria: <span>{res.carga}kg/m²</span>
              </p>
              <p>
                Sobrecarga reglamentaria: <span>{res.sobreCarga} kg/m²</span>
              </p>
              <p>
                Carga útil: <span>{res.cargaTotal} kg/m²</span>
              </p>
            </article>
         
        </div>
        <div className="col-12 col-sm-12 col-md-6 col-lg-6 style-calculadora-derecha">                 
            <article className="md:w-1/2 rounded-lg formulario-styles">
              <h2>Dimensiones de Cálculo</h2>
              <p>
                Luz: <span>{res.luzOriginal} mts</span>
              </p>
              <p>
                Ancho: <span>{res.anchoOriginal} mts</span>
              </p>
              <p>
                Superficie: <span>{res.superficie} m²</span>
              </p>
            </article>
          </div>
        
      </section>

      {/* Seccion Forjado Opcion 1 */}
      { res?.pcarga === 'Si' ?
      <section
        id="institucional__contacto"
        className="container display-form flex-no-wrap mb-5 resultados-calculadora "
        //className="container display-form flex-no-wrap mb-5 resultados-calculadora "
        >
        <div className="col-sm-12 col-md-6 col-lg-6 style-calculadora-izquierda">
          {/* Seccion columna izquierda */}
          
            
           

            <article className="col-6-mr-izquierda">
              <h2>
                Características del Forjado Opción 1
              </h2>
              <p>
                Viguetas Serie: <span>{res.row_prov?.serie}</span>
              </p>
              <p>
                Capacidad de carga del forjado: <span>{res?.cargaadmisible} kg/m²</span>
              </p>
              <p>
                Material de bovedilla: <span>EPS</span>
              </p>
              <p>
                Altura de bovedilla: <span>{res?.espesorbov} cm</span>
              </p>
              <p>
                Espesor capa: <span>{res?.espesorcapa} cm</span>
              </p>
              <p>
                Espesor total: <span>{res?.espesortotal} cm</span>
              </p>
              <p>
                Precio propio del forjado: <span>{res?.pesopropio} kg/m²</span>
              </p>
            </article>
        </div>
        <div className="col-12 col-sm-12 col-md-6 col-lg-6 style-calculadora-derecha">
         
            
           
            <article className="resultados-derecha">
              <h2>
                Cómputo Métrico de Materiales Opción 1
              </h2>
              <div >
              <p>
                {res?.cantidadvig1} Viguetas <span>de {res.luzOriginal} mts. de la serie {res.row_prov?.serie}</span>
              </p>
              <p>
                {res?.cantidadbov1} Bovedillas <span>1 metro</span>
              </p> 
              <p>
                {res?.volhomigon.toFixed(2)} m³ <span>de Hormigón H-17 (mínimo)</span>
              </p>
              <p>
              {res?.puntal === '0' ? (
              <span>Este forjado no requiere apuntalamiento</span>) : res.puntal === '1' ? (
              <span>Este forjado requiere apuntalamiento en el centro de su luz</span>) : res.puntal === '2' ? (
              <span>Este forjado requiere dos líneas de puntales a lo largo de su luz</span> ) : null}
              </p>
              <img
                src={simple}
                alt="bovedilla-hormigon"
                />
                </div>
            </article>
        
        </div>
      </section> : null }

      {/* Seccion Forjado Opcion 2 */}
      { res?.pcarga2 === 'Si' ?
      <section
      id="institucional__contacto"
      className="container display-form flex-no-wrap mb-3 resultados-calculadora"
      >
        <div className="col-sm-12 col-md-6 col-lg-6 style-calculadora-izquierda">
          {/* Seccion columna izquierda */}
         
            <article className="md:w-1/2 rounded-lg formulario-styles">
            <h2>
                Características del Forjado Opción 2
              </h2>
              <p>
                Viguetas Serie: <span>{res.row_prov?.serie}</span>
              </p>
              <p>
                Capacidad de carga del forjado: <span>{res?.cargaadmisible2} kg/m²</span>
              </p>
              <p>
                Material de bovedilla: <span>EPS</span>
              </p>
              <p>
                Altura de bovedilla: <span>{res?.espesorbov2} cm</span>
              </p>
              <p>
                Espesor capa: <span>{res?.espesorcapa2} cm</span>
              </p>
              <p>
                Espesor total: <span>{res?.espesortotal2} cm</span>
              </p>
              <p>
                Precio propio del forjado: <span>{res?.pesopropio2} kg/m²</span>
              </p>
            </article>
        </div>
        <div className="col-12 col-sm-12 col-md-6 col-lg-6 style-calculadora-derecha">
         
            <article
              id="resultados-derecha"
              className="md:w-1/2 rounded-lg formulario-styles resultados-derecha"
              >
                 <h2>
                Cómputo Métrico de Materiales Opción 2
              </h2>
              <p>
                {res?.cantidadvig2} Viguetas <span>de {res.luzOriginal} mts. de la serie {res.row_prov?.serie}</span>
              </p>
              { res.row_prov2?.material === 'EPS' ?
              <p>
                {res?.cantidadbov2/2} Bovedillas <span>1 metro o</span> {res?.cantidadbov2} <span>de 0.50 metros</span> de {res?.espesorbov2} cm
              </p> :
              <p>
                {res?.cantidadbov2} Bovedillas <span>1 metro</span>
              </p>
              }
              <p>
                {res?.volhomigon2.toFixed(2)} m³ <span>de Hormigón H-17 (mínimo)</span>
              </p>
              <p>
              {res?.puntal2 === '0' ? (
              <span>Este forjado no requiere apuntalamiento</span>) : res.puntal2 === '1' ? (
              <span>Este forjado requiere apuntalamiento en el centro de su luz</span>) : res.puntal2 === '2' ? (
              <span>Este forjado requiere dos líneas de puntales a lo largo de su luz</span> ) : null}
              </p>
              <img
                className="w-100"
                src={doble}
                alt="bovedilla-hormigon"
                />
            </article>
        </div>
      </section> : null }
      <div className="container col-12 install-products-components">
      <button onClick={limpiar} className="button-resultscalculadora mt-3 mb-4 m-auto d-flex shadow">
                Nuevo cálculo
            </button>
        <div className="install-products-components">
          <div className="row advertise align-items-center">
            <div className="col-4 text-center ">
              <p>
                <WarningAmberIcon fontSize="large" className="icon-advertise" />
              </p>
            </div>
            <div className="col-8 mt-2">
              <p className="text-advertise">
                Tensolite S.A. no se responsabiliza por el uso inadecuado de
                este programa. En caso de duda consultar a un profesional
                competente
              </p>
            </div>
          </div>
        </div>
      </div>
    </section> : null}
  </>
  )
}

export default ResultsCalculator;
